import { render, staticRenderFns } from "./LessSales.vue?vue&type=template&id=c841198c"
import script from "./LessSales.vue?vue&type=script&lang=js"
export * from "./LessSales.vue?vue&type=script&lang=js"
import style0 from "./LessSales.vue?vue&type=style&index=0&id=c841198c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports